import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from "../../environments/environment";
import { buildAetUserContext, getPreferredUserIdentifier } from '../core/constant/user-context.util';

@Injectable({
	providedIn: 'root'
})
export class ConnectionsService {
  static exportAsExcelFile(_exportAsExcelFile: any) {
    throw new Error('Method not implemented.');
  }

  baseURL = environment.baseAPIURL;
	constructor( private readonly http  : HttpClient) { }

	getConnections(data) {

		return this.http.get(`${this.baseURL}/aetHistory/getDetailedConnections/${data.eventId}/${data.pageNo}/${data.pageSize}`, { responseType: 'json' }
		)
			.pipe(catchError(this.handleError));
	}
	reopen(eventId, toyotaGUID) {
		const userIdentifier = getPreferredUserIdentifier(toyotaGUID);
		const requestBody = {
			event: { eventId },
			userReqDto: buildAetUserContext(),
		};
		return this.http.put(`${this.baseURL}/aetHistory/reopenAetEvent/${eventId}`, requestBody, { responseType: 'json' })
		.pipe(catchError(this.handleError));
	}
	private handleError(error: HttpErrorResponse) {
		return throwError(error.message || "Server Error");
	}
}